import {Model} from './Model';
import {OrderItem} from './OrderItem';
import {LocalStorageObject} from '../Utilities';
import {CustomerDataDTO, ShopUrlsDTO} from '../DTOs';
import {AdditionalOrderItemConfiguration} from './AdditionalOrderItemConfiguration';

export class Order extends Model implements LocalStorageObject {
  public orderNumber: number = 0;
  public orderNumberCompiled: string = '';
  public changedDate: Date = new Date;
  public buyerEmail: string = '';
  public buyerData: CustomerDataDTO | null = null;
  public invoiceData: CustomerDataDTO | null = null;
  public orderItems: Array<OrderItem> = [];
  public shopUrls: ShopUrlsDTO = new ShopUrlsDTO();
  public codes: Array<string> = [];
  public additionalOrderItemConfigurations: Array<AdditionalOrderItemConfiguration> = [];
  public token: string | null = null;

  constructor(data: any) {
    super(data);
    this.orderNumber = data.orderNumber;
    this.orderNumberCompiled = data.orderNumberCompiled;
    this.changedDate = data.changedDate;
    this.buyerEmail = data.buyerEmail;
    this.token = data.token || null;
    this.buyerData = data.buyerData ? (new CustomerDataDTO()).fromData(data.buyerData) : null;
    this.invoiceData = data.invoiceData ? (new CustomerDataDTO()).fromData(data.invoiceData) : null;
    this.orderItems = data.orderItems ? data.orderItems.map(oi => new OrderItem(oi)) : [];
    this.codes = data.codes;
    this.additionalOrderItemConfigurations =
      data.additionalOrderItemConfigurations
        ? data.additionalOrderItemConfigurations.map(aoic => new AdditionalOrderItemConfiguration(aoic))
        : [];
  }

  fromStorage(data: any) {
    return new Order(data);
  }

  toString(): string {
    return `Order<${this.orderNumber}>`;
  }
}
